import React, { FC, forwardRef, Ref } from 'react';
import { VisuallyHidden, InputProps} from '@chakra-ui/core'

export interface HiddenProps extends InputProps {
  checked: boolean
}

export const Hidden : FC<HiddenProps> = forwardRef((props: HiddenProps, ref: Ref<any>)  => {
    return <VisuallyHidden ref={ref} {...props} />
})
